// **********************************************************
// Secondary Nav
// **********************************************************

const secondaryNavElem = document.querySelector('.sc-secondary-nav');

window.addEventListener('load', () => {
  if (secondaryNavElem) {
    const { hash } = window.location;
    if (hash) {
      const hashValue = hash.slice(1);
      document.querySelectorAll('.sc-secondary-nav .secondary-nav__link').forEach((element) => {
        if (hashValue === element.getAttribute('data-id')) {
          element.classList.add('is-active');
        }
      });
    }
  }
});

attachEvent('.sc-secondary-nav .secondary-nav__item', 'click', (ev) => {
  const activeItems = document.querySelectorAll('.sc-secondary-nav .secondary-nav__link');
  removeActiveClass(activeItems);
  ev.target.classList.add('is-active');
});
